namespace Matrix.Dashboards {
    export interface WidgetCatalogData {
        WidgetOptions?: { [key: string]: any };
        LayoutW?: number;
        LayoutH?: number;
    }
}
